<gen-monorepo-header-marketplace></gen-monorepo-header-marketplace>
<ng-container *ngIf="checkShowFooter()">
  <nz-breadcrumb nzAutoGenerate *ngIf="title !== ''">
    <nz-breadcrumb-item>
      <a routerLink="/">Início</a>
    </nz-breadcrumb-item>
  </nz-breadcrumb>
</ng-container>

<router-outlet></router-outlet>
<app-coupon-footer *ngIf="checkShowFooter()"></app-coupon-footer>
